import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide16Closing.css';

function Slide16Closing() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 16 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-closing">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="closing-bg">
        <div className="closing-grid" />
        <div className="closing-glow" />
        <div className="closing-noise" />
      </div>

      <div className="closing-content">
        <motion.div className="closing-label" {...fadeUp(0.05)}>
          CLOSING
        </motion.div>
        <motion.h1 className="closing-title" {...fadeUp(0.12)}>
          Thank you for your time
        </motion.h1>
      </div>
    </div>
  );
}

export default Slide16Closing;
